

const isResolvedResource = require('./is-resolved-resource');

module.exports = (collection) => {
  if (!Array.isArray(collection)) {
    throw new Error('Expected array.');
  }

  let allResolved = true;

  collection.forEach((resource) => {
    if (!isResolvedResource(resource)) {
      allResolved = false;
    }
  });

  return allResolved;
};
